import IndustryPageTemplate from "./IndustryPageTemplate";
import { financialAdvisorsData } from "@/data/financialAdvisors";

export default function FinancialAdvisorsPage() {
  return <IndustryPageTemplate data={financialAdvisorsData} />;
}
